module.exports = __webpack_public_path__ + "static/media/hexagon-star.41c79265.mp4";